/*eslint-disable*/ 
//This file was generated by `tools/generate-error-classes.ts`.
//Changes made to this file will be overwritten.
//Moreover, this file should be excluded from your linter, formatter and VCS.
import BaseError from "@/modules/errors/classes/BaseError.gen.ts";
export default class CoreAdminSettingsFetchError extends BaseError {
    constructor(originalError?: Error) { super(1001005001, "fetch", "core", "admin_settings", "core_admin_settings_fetch", originalError); }
}
